import React from 'react';
import UpcomingPostsSkeleton from './UpcomingPostsSkeleton';
import ProfileInformationSkeleton from './ProfileInformationSkeleton';
import StatsSectionSkeleton from './StatsSectionSkeleton';
import ConnectedAccountsSkeleton from './ConnectedAccountsSkeleton';
import ReachChartSkeleton from './ReachChartSkeleton';

const PageSkeleton = () => (
  <div className='space-y-8'>
    {/* Profile Information */}
    <ProfileInformationSkeleton />

    {/* Upcoming Posts */}
    <UpcomingPostsSkeleton />

    {/* Stats & Connected Accounts Row */}
    <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
      <StatsSectionSkeleton />
      <ConnectedAccountsSkeleton />
    </div>

    {/* Instagram Reach Chart */}
    <ReachChartSkeleton />
  </div>
);

export default PageSkeleton;
